import "./styles.less";

import { Affix, Col, Row, Space } from "antd";

import { Favorite } from "../../../Components/Property/Favorite/web";
import { FormButton } from "../../../Components/Property/InformationRequest/LeadButtons/FormButton/web";
import { LocationTag } from "../../../Components/Property/LocationTag/web";
import { PriceTag } from "../../../Components/Property/PriceTag/web";
import React from "react";
import { SocialShare } from "../../../Components/Property/SocialShare/web";
import { Title } from "../../../Components/Property/Title/web";
import { isTemporal } from "../../../Utils/Functions";
import { useTheme } from "../../../Styles/ThemeHook";

export const PropertyAffixHeader = ({
	id,
	listing,
	mode = "auto",
}: {
	id: string;
	listing: Listing;
	mode;
}) => {
	const { theme } = useTheme();
	return (
		<Affix className={"pd_affix_top"} offsetTop={theme.headerHeight}>
			<div className="container pd-container">
				<Row className={"pd-affix-row"} gutter={theme.spacing.xlSpacing}>
					<Col span={8}>
						<Title
							level={4}
							hideInformation={true}
							limitLength={1}
							title={listing.title}
						/>
						<LocationTag id={id} />
					</Col>
					{!isTemporal(listing.operation_type?.id) && listing?.price ? (
						<Col flex={1}>
							<PriceTag
								price={listing.price}
								priceVariation={listing.price_variation}
								commonExpenses={listing.commonExpenses}
								temporalCurrency={listing.temporal_currency}
								temporalPrice={listing.temporal_price}
								operationType={listing.operation_type}
								isProject={listing.isProject}
							/>
						</Col>
					) : null}
					<Col>
						<Space size={theme.spacing.lgSpacing}>
							<Favorite id={id} isDisabledProperty={!listing.active} />
							<SocialShare id={id} mode={mode} isDisabledProperty={!listing.active} />
							<FormButton id={id} isDisabledProperty={!listing.active} />
						</Space>
					</Col>
				</Row>
			</div>
		</Affix>
	);
};
